import { AnalyticsMetaKeys as key } from '../../../../../services/analytics/formatters/meta-keys'

export interface IViafouraAttrFormatter {

    format(attrs: string[], obj: any): object
}

export class ViafouraAttrFormatter implements IViafouraAttrFormatter {

    public format(data: any): object {
        const obj: any = {}
        if (data) {
            if (data.likeRcvd) {
                obj[key.VIA_LIKE_RCVD] = data.likeRcvd
            }
            if (data.likeMade) {
                obj[key.VIA_LIKE_MADE] = data.likeMade
            }

            if (data.dislkeRcvd) {
                obj[key.VIA_DISLK_RCVD] = data.dislkeRcvd
            }
            if (data.dislkMade) {
                obj[key.VIA_DISLK_MADE] = data.dislkMade
            }
        }
        return {
            ...obj,
            ...this.formatComment(data),
            ...this.formatSocial(data)
        }
    }

    public formatSocial(data: any): object {
        const obj: any = {}
        if (data.sclLgnId) {
            obj[key.VIA_SCL_LGIN_ID] = data.sclLgnId
        }
        if (data.sclLgnPrvdr) {
            obj[key.VIA_SCL_LGIN_PRDR] = data.sclLgnPrvdr
        }
        if (data.userPrvlg) {
            obj[key.VIA_USR_PRVLG] = data.userPrvlg
        }
        if (data.rankSubCount) {
            obj[key.VIA_RNK_SUB_CNT] = data.rankSubCount
        }
        return obj
    }

    public formatComment(data: any): object {
        const obj: any = {}
        if (data.totalCmnts) {
            obj[key.VIA_TOTAL_CMNTS] = data.totalCmnts
        }
        if (data.dateCreated) {
            obj[key.VIA_DATE_CRETED] = data.dateCreated
        }
        if (data.totalCmntsMade) {
            obj[key.VIA_TOTAL_CMNTS_MADE] = data.totalCmntsMade
        }
        if (data.totalCmntsRcvd) {
            obj[key.VIA_TOTAL_CMNTS_RCVD] = data.totalCmntsRcvd
        }
        if (data.rankCmntsMade) {
            obj[key.VIA_RNK_CMNTS_MADE] = data.rankCmntsMade
        }
        if (data.rankCmntsRcvd) {
            obj[key.VIA_RNK_CMNTS_RCVD] = data.rankCmntsRcvd
        }
        if (data.cmntsRnkOvral) {
            obj[key.VIA_RNK_CMNTS_OVRAL] = data.cmntsRnkOvral
        }
        if (data.cmntsRating) {
            obj[key.VIA_CMNTS_RTNG] = data.cmntsRating
        }
        if (data.cmntLvl) {
            obj[key.VIA_CMNTS_LVL] = data.cmntLvl
        }
        if (data.cmntType) {
            obj[key.VIA_CMNTS_TYP] = data.cmntType
        }
        return obj
    }
}
